<div class="container">
    <h1 class="display-4">Your Personal Information</h1>
    <h3 class="lead">Your Hunter Strategy recruiter has provided some 
        basic details about you. Please submit the remaining
        information below to initiate your security clearance verification.
    </h3>
</div>